<template>
  <svg
    id="flag-icon-css-cs"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
  >
    <path fill="#ffffff" d="M0 0h640v240H0z" />
    <path fill="#d7141a" d="M0 240h640v240H0z" />
    <path fill="#11457e" d="M0 0l320 240L0 480z" />
  </svg>
</template>

<script>
export default {
  name: 'CsFlag',
  props: {
    height: {
      type: String,
      default: '20px'
    }
  }
}
</script>
